import { render } from "./KinshipModal.vue?vue&type=template&id=4cae42f7&scoped=true"
import script from "./KinshipModal.vue?vue&type=script&lang=js"
export * from "./KinshipModal.vue?vue&type=script&lang=js"

import "./KinshipModal.vue?vue&type=style&index=0&id=4cae42f7&scoped=true&lang=css"

import exportComponent from "D:\\EME_MARKETING_AND_CONSULTING\\_Proyectos\\bookapps\\Apps Code\\web-admin-bookapps-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cae42f7"]])

export default __exports__